import { ASSETS } from "@/data/site";
import { QuoteButton, CallButton } from "@/components/Buttons";
import { Reveal, SectionLabel } from "@/components/Reveal";

export const CtaBanner = () => (
  <section className="relative overflow-hidden bg-brand-blue py-20 md:py-28">
    <div
      className="absolute inset-0 opacity-25"
      style={{ backgroundImage: `url(${ASSETS.vanHero})`, backgroundSize: "cover", backgroundPosition: "center" }}
    />
    <div className="absolute inset-0 bg-gradient-to-r from-brand-blue via-brand-blue/90 to-brand-blue/40" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <SectionLabel dark>Request a Free Quote</SectionLabel>
        <h2 className="mt-5 max-w-3xl font-display text-4xl md:text-5xl font-bold tracking-tight text-white text-balance">
          Local, qualified and ready to help.
        </h2>
        <p className="mt-4 max-w-xl text-lg text-slate-300">
          Book your free, no-obligation quote today and experience workmanship you can rely on.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <QuoteButton testId="cta-quote" />
          <CallButton dark testId="cta-call" />
        </div>
      </Reveal>
    </div>
  </section>
);
